import { useMutation, useQuery } from '@tanstack/react-query';
import { DropdownItem } from '../../types/WebPush';
import {
    WebPushActionRequest,
    WebPushSendRequest,
    WebSiteCapabilityResponse,
} from '../webPush/types/webPush';
import {
    requestSendWebPush,
    requestWebPushGenerateInternal,
    requestWebPushSites,
    requestWebSiteCapabilities,
    requestWebSiteCapabilityList,
} from '../webPush/webPush';

export function useSendWebPush() {
    return useMutation({
        mutationFn: async (data: WebPushSendRequest) => (await requestSendWebPush(data)).data,
        onSuccess: async data => {
            // queryClient.invalidateQueries();
        },
    });
}

export function useWebPushSites() {
    return useQuery<DropdownItem[], Error>({
        queryKey: [`webPush`, 'sites'],
        queryFn: async ({ signal }) => {
            return (await requestWebPushSites(signal)).data;
        },
    });
}

export function useWebPushGetCapabilities(siteId: number) {
    return useQuery<WebSiteCapabilityResponse, Error>({
        queryKey: [`capabilities-${siteId}`],
        queryFn: async ({ signal }) => {
            return (await requestWebSiteCapabilities(siteId, signal)).data;
        },
    });
}

export function useWebPushGetCapabilityList(siteId: number, type: string) {
    return useQuery<DropdownItem[], Error>({
        queryKey: [`capabilities-${siteId}`, `${type}`],
        queryFn: async ({ signal }) => {
            return (await requestWebSiteCapabilityList(siteId, type, signal)).data;
        },
        enabled: !!type,
        retry: false,
    });
}

export function useWebPushGenerateInternal(data: WebPushActionRequest) {
    return useQuery<WebPushSendRequest, Error>({
        queryKey: [`generate`, data.data],
        queryFn: async ({ signal }) => {
            return (await requestWebPushGenerateInternal(data, signal)).data;
        },
        enabled: !!data.data && !isNaN(+data.data),
        retry: false,
    });
}
